import React, { useRef, useEffect } from 'react';
import gsap from 'gsap';
import { Link } from 'react-router-dom';
import img1 from '../asserts/imgg1.png';
import img2 from '../asserts/imgg2.png';
import img3 from '../asserts/imgg6.png';
import './HomePage.css';
import AsteriskNav from './Asterisknav';

const HomePage = () => {
    const navRef = useRef(null);
    const tabRef = useRef(null);
    const allEventsRef = useRef(null);
    const cardsRef = useRef(null);
    const featuredRef = useRef(null);
    const featuredCardRef = useRef(null);

    useEffect(() => {
        const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

        gsap.set(navRef.current, { opacity: 0, y: -50 });
        gsap.set(tabRef.current, { opacity: 0, y: 40, scale: 0.97 });
        gsap.set(allEventsRef.current, { opacity: 0, x: -30 });
        gsap.set(Array.from(cardsRef.current.children), { opacity: 0, y: 30 });
        gsap.set(featuredRef.current, { opacity: 0, x: -30 });
        gsap.set(featuredCardRef.current, { opacity: 0, y: 50, scale: 0.95 });

        tl.to(navRef.current, { opacity: 1, y: 0, duration: 0.9 })
          .to(tabRef.current, { opacity: 1, y: 0, scale: 1, duration: 0.7 }, '-=0.4')
          .to(allEventsRef.current, { opacity: 1, x: 0, duration: 0.6 }, '-=0.3')
          .to(Array.from(cardsRef.current.children), { opacity: 1, y: 0, stagger: 0.12, duration: 0.55 }, '-=0.3')
          .to(featuredRef.current, { opacity: 1, x: 0, duration: 0.6 }, '-=0.2')
          .to(featuredCardRef.current, { opacity: 1, y: 0, scale: 1, duration: 0.7, ease: 'back.out(1.2)' }, '-=0.3');
    }, []);

    return (
        <div className="home-wrapper">
            <div className="mobile-container">
                <main className="home-screen">

                    <AsteriskNav active="home" navRef={navRef} />

                    <div className="hp-tab-sheet" ref={tabRef}>
                        <div className="hp-tab-indicator" aria-hidden="true"></div>

                        <section className="hp-section" aria-labelledby="all-events-title">
                            <header className="hp-section-header" ref={allEventsRef}>
                                <span className="hp-section-dot" aria-hidden="true"></span>
                                <h2 className="hp-section-title" id="all-events-title">TOP EVENTS</h2>
                                <span className="hp-section-line" aria-hidden="true"></span>
                            </header>

                            <div className="hp-cards-wrap" ref={cardsRef}>
                                <div className="hp-cards-group">
                                    <article className="hp-event-card hp-event-card--left">
                                        <div className="hp-event-card-img-wrap">
                                            <img src={img1} alt="Modernist Co interior design exhibition" className="hp-event-card-img" />
                                        </div>
                                        <div className="hp-event-card-body">
                                            <p className="hp-event-date">
                                                <svg aria-hidden="true" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <rect x="3" y="4" width="18" height="18" rx="2"/>
                                                    <line x1="16" y1="2" x2="16" y2="6"/>
                                                    <line x1="8" y1="2" x2="8" y2="6"/>
                                                    <line x1="3" y1="10" x2="21" y2="10"/>
                                                </svg> <span className="sr-only">Date: </span> May 22
                                            </p>
                                            <h3 className="hp-event-name">MODERNIST CO</h3>
                                            <p className="hp-event-price"><span className="sr-only">Price: </span><span className="hp-price-num">250</span> EGP</p>
                                        </div>
                                    </article>
                                    <Link to="/details" className="no-underline-link" aria-label="will go to details page">
                                        <article className="hp-event-card hp-event-card--right">
                                            <div className="hp-event-card-img-wrap">
                                                <img src={img2} alt="Design & Code architecture workshop" className="hp-event-card-img" />
                                            </div>
                                            <div className="hp-event-card-body">
                                                <p className="hp-event-date">
                                                    <svg aria-hidden="true" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                        <rect x="3" y="4" width="18" height="18" rx="2"/>
                                                        <line x1="16" y1="2" x2="16" y2="6"/>
                                                        <line x1="8" y1="2" x2="8" y2="6"/>
                                                        <line x1="3" y1="10" x2="21" y2="10"/>
                                                    </svg> <span className="sr-only">Date: </span> May 25
                                                </p>
                                                <h3 className="hp-event-name">DESIGN & CODE</h3>
                                                <p className="hp-event-price"><span className="sr-only">Price: </span><span className="hp-price-num">250</span> EGP</p>
                                            </div>
                                        </article>
                                    </Link>
                                </div>
                            </div>
                        </section>

                        <section className="hp-section" aria-labelledby="featured-events-title">
                            <header className="hp-section-header">
                                <span className="hp-section-dot" aria-hidden="true"></span>
                                <h2 className="hp-section-title" id="featured-events-title" ref={featuredRef}>FEATURED EVENTS</h2>
                                <span className="hp-section-line" aria-hidden="true"></span>
                            </header>

                            <article className="hp-featured-card" ref={featuredCardRef}>
                                <div className="hp-featured-img-wrap">
                                    <img src={img3} alt="Eco Design 2026 sustainable architecture showcase" className="hp-featured-img" />
                                    <div className="hp-featured-badge">
                                        <svg aria-hidden="true" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
                                            <polyline points="17 6 23 6 23 12"/>
                                        </svg> TRENDING
                                    </div>
                                </div>
                                <div className="hp-featured-body">
                                    <h3 className="hp-featured-name">ECO DESIGN 2026</h3>
                                    <p className="hp-featured-desc">Environmental solutions and sustainable materials for responsible design</p>
                                    <div className="hp-featured-meta">
                                        <span className="hp-featured-meta-item">
                                            <svg aria-hidden="true" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <rect x="3" y="4" width="18" height="18" rx="2"/>
                                                <line x1="16" y1="2" x2="16" y2="6"/>
                                                <line x1="8" y1="2" x2="8" y2="6"/>
                                                <line x1="3" y1="10" x2="21" y2="10"/>
                                            </svg> <span className="hp-meta-label">DATE</span> May 15
                                        </span>
                                        <span className="hp-featured-meta-item">
                                            <svg aria-hidden="true" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                                                <circle cx="12" cy="10" r="3"/>
                                            </svg> <span className="hp-meta-label">LOCATION</span> Cairo
                                        </span>
                                    </div>
                                    <div className="hp-featured-footer">
                                        <div className="hp-featured-price-wrap">
                                            <span className="hp-featured-from">FROM</span>
                                            <span className="hp-featured-price">150<span className="hp-featured-currency">EGP</span></span>
                                        </div>
                                        <button className="hp-view-btn" aria-label="View Eco Design 2026 Event Details">VIEW EVENT <svg aria-hidden="true" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M5 12h14M12 5l7 7-7 7"/>
                                        </svg></button>
                                    </div>
                                </div>
                            </article>
                        </section>

                    </div>
                </main>
            </div>
        </div>
    );
};

export default HomePage;